export const resolveShowColumnHeadersFromUrl = (urlParams: URLSearchParams): boolean | undefined => {
  const showColumnHeaders = urlParams.get("showColumnHeaders");

  if (showColumnHeaders === "true") {
    return true;
  }
  if (showColumnHeaders === "false") {
    return false;
  }

  return undefined;
};

export const encodeShowColumnHeadersToUrl = (
  urlParams: URLSearchParams,
  showColumnHeaders: boolean | undefined,
): URLSearchParams => {
  const updatedParams = new URLSearchParams(urlParams);

  if (showColumnHeaders === true) {
    updatedParams.set("showColumnHeaders", "true");
  } else if (showColumnHeaders === false) {
    updatedParams.set("showColumnHeaders", "false");
  } else {
    updatedParams.delete("showColumnHeaders");
  }

  return updatedParams;
};
